import * as THREE from "three";

const CANVAS_W = 256;
const CANVAS_H = 64;

export function makeNametag(text: string, color: string): THREE.Sprite {
  const canvas = document.createElement("canvas");
  canvas.width = CANVAS_W;
  canvas.height = CANVAS_H;
  const ctx = canvas.getContext("2d")!;
  ctx.clearRect(0, 0, CANVAS_W, CANVAS_H);
  ctx.fillStyle = "rgba(0,0,0,0.55)";
  ctx.fillRect(0, 8, CANVAS_W, CANVAS_H - 16);
  ctx.fillStyle = color;
  ctx.fillRect(0, 8, 6, CANVAS_H - 16);
  ctx.fillStyle = "#ffffff";
  ctx.font = "bold 26px sans-serif";
  ctx.textAlign = "left";
  ctx.textBaseline = "middle";
  ctx.fillText(text.slice(0, 16), 16, CANVAS_H / 2);

  const tex = new THREE.CanvasTexture(canvas);
  tex.needsUpdate = true;

  const mat = new THREE.SpriteMaterial({ map: tex, depthTest: false, transparent: true });
  const sprite = new THREE.Sprite(mat);
  sprite.scale.set(2.0, 0.5, 1);
  sprite.position.y = 2.4;
  sprite.renderOrder = 999;
  return sprite;
}

export function updateNametag(sprite: THREE.Sprite, text: string, color: string): void {
  const tex = sprite.material.map as THREE.CanvasTexture | null;
  if (!tex) return;
  const canvas = tex.image as HTMLCanvasElement;
  const ctx = canvas.getContext("2d")!;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = "rgba(0,0,0,0.55)";
  ctx.fillRect(0, 8, canvas.width, canvas.height - 16);
  ctx.fillStyle = color;
  ctx.fillRect(0, 8, 6, canvas.height - 16);
  ctx.fillStyle = "#ffffff";
  ctx.font = "bold 26px sans-serif";
  ctx.textAlign = "left";
  ctx.textBaseline = "middle";
  ctx.fillText(text.slice(0, 16), 16, canvas.height / 2);
  tex.needsUpdate = true;
}
